// extracted by mini-css-extract-plugin
module.exports = {"title":"NoSavedCredit_title__3mK1_","description":"NoSavedCredit_description__12Xsu","heartIcon":"NoSavedCredit_heartIcon__3m1Dp","homeLink":"NoSavedCredit_homeLink__1B1r9"};